export default __webpack_public_path__ + "6a0433ded6c76f304ec42643bf35f3d7.png";